(function () {
  if (window.bvReadReviewsHandler) return;
  window.bvReadReviewsHandler = true;

  var SETTLE_MS = 1000;
  var MAX_MS = 4000;
  var cancelEvents = ['wheel', 'touchstart', 'keydown'];

  // Lazy sections above the reviews row render while the page scrolls and push it down, so a single
  // scrollTo lands in the wrong place. Re-aim at the row until the layout stops moving.
  function scrollToRow(row) {
    var cancelled = false;
    var start = performance.now();
    var lastMove = start;

    function cancel() {
      cancelled = true;
    }

    function getTarget() {
      var header = document.querySelector('.header-wrapper, sticky-header, .shopify-section-group-header-group');
      var offset = header ? header.getBoundingClientRect().height : 0;
      return Math.max(0, row.getBoundingClientRect().top + window.scrollY - offset - 16);
    }

    function finish() {
      cancelEvents.forEach(function (name) {
        window.removeEventListener(name, cancel);
      });
    }

    function tick(now) {
      if (cancelled || now - start > MAX_MS) return finish();
      var target = getTarget();
      if (Math.abs(target - window.scrollY) > 1) {
        window.scrollTo({ top: target, behavior: 'instant' });
        lastMove = now;
      } else if (now - lastMove > SETTLE_MS) {
        return finish();
      }
      window.requestAnimationFrame(tick);
    }

    cancelEvents.forEach(function (name) {
      window.addEventListener(name, cancel, { passive: true });
    });
    window.requestAnimationFrame(tick);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-bv-show="rating_summary"] .bv_main_rating_button, [data-bv-native-rating] .bv-native-rating__button');
    if (!button) return;
    var row = document.querySelector('details-disclosure[data-reviews-row]');
    if (!row) return;

    event.preventDefault();
    event.stopPropagation();

    row.openDetails();
    scrollToRow(row);
  }, true);
})();
